import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  button {
    background: #0085ff !important;
    color: #ffffff !important;
    border-radius: 8px;
    font-weight: 700;
    height: 40px;
    padding: 0 12px;
    border: none;
    &:hover {
      background: #0277e2 !important;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
`

export const TooltipTitle = styled.div`
  width: 160px;
`
